import { render } from "./v-popup.vue?vue&type=template&id=a8e706f8&lang=true"
import script from "./v-popup.vue?vue&type=script&lang=js"
export * from "./v-popup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__